<template>
  <div>
    <div class="row">
      <div class="col">
        <h4><b>Behavior Trackers</b></h4>
        <p>Behavior trackers are created for students individually and users are assigned to fill them out.</p>
      </div>
    </div>
    <div class="row text-left">
      <div class="col">
        <h5>Tracker Templates</h5>
        <p>
          Tracker templates are very similar to score templates in that they are
          used to define what data is kept each time a behavior tracker is
          filled out (similar to Google Forms). Each template made is reusable
          by everyone in the school so it is important to give it a name that
          means something like "John's Behavior Tracker Term 1", "Physical and
          Verbal Agression", etc. Tracker templates consist of 1 or more inputs
          that determine what data is entered for the tracker.
        </p>
        <h5>Template Input</h5>
        <p>
          Template inputs are a single point of data taken every time a tracker is filled out for a student. Template inputs can be one of the following types:
          <ul>
            <li v-for="templateInputType in TemplateInputTypes.slice().sort($orderByOrder)" :key="templateInputType.Template_Input_Type_Id">
              {{ templateInputType.Title }}: {{ templateInputType.Description }}
            </li>
          </ul>
          Each template input has a request. The <b>Request</b> is the prompt that appears when a user is entering data for that input. Multiple score inputs can be added to a tracker template when more than one data point is needed.
        </p>
        <h5>Trackers</h5>
        <p>
          What sets behavior trackers apart from a normal score is that behavior
          trackers have settings for which the tracker is filled out and
          individuals are assigned to the behavior tracker allowing them to fill
          out the behavior tracker.
          <br /><b>Settings</b> indicate which time of day and location the
          behavior tracker is being filled out for. These commonly would include
          classroom, recess, art, etc. or could be used to designate which class
          they are in for the teacher filling it out. <br /><b
            >Assigning users</b
          >
          to a behavior tracker allows them to fill out the behavior tracker for
          a student. This allows for classroom teachers to sign up for Special
          Data and then fill out the tracker data for students that attend their
          classroom. They only see the students that they have been assigned to
          fill out trackers for. This is like giving them permission only to
          fill out the specified tracker for the student. <br />Each time a
          tracker is filled out, it records who the tracker was filled out by so
          that any questions about specific behavior can be addressed with the
          correct person.
        </p>
        <h5>Behavior Tracker Example</h5>
        <p>
          As an example, let's go through the process of creating a behavior tracker. In this example 
          we will be tracking data for a student who has a goal to decrease physical agression as well as a goal to increase hand raising.
          First, we would create the behavior tracker by clicking on the student's name. In this case it is for a studnet named Ben. We will 
          then click "add tracker", and give it a name such as, "Ben's Term 1 Behavior Tracker". This name will appear under
          the student as the link to their behavior tracker. You may wish to add Ben's actual goal to the tracker description but it is not
          required. Next, choose settings (any educational settings where you or other teachers who work with Ben will be recording 
          data toward Ben's behavior goals). There are several pre-populated settings that you can choose from or you may add your
          own. To track Ben's progress toward his goal we will next be creating a template to input his data. Name the score template something 
          you can use later in the year or next year. If Ben's goals are simliar to other students, you may want to title the template "General Physical Aggression
          and Hand Raising Behaivor Tracker". This will allow you, and other teachers, to use this template for other students with similar goals. The name 
          of the template will not show up anywhere on the student's data. To measure incidences of physical aggression we are going to add a score input of yes/no explain. 
          For the Question/Information Request we will write, "Did the student have any incidences of physical aggression? If yes explain." This is what will show up when you 
          other teachers are entering data for Ben. To add another score input for Ben click the "Add Score Input" button. For this score input we will use a percentage and for the
          information request write "What was the average percent accuracy of the student raising their hand in class vs shouting out?" When you create the template you will see a 
          summary and then be able to add users who need access to the behavior tracker. 
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    TemplateInputTypes: Array
  }
}
</script>